import { API_URLS } from "../constants";
import {
  getRequest,
  putRequest,
  formDataPutRequest,
} from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const { RESTAURANT_THEME } = API_URLS;

//Function to update theme setting in database
const updateThemeSettings = (data) => {
  return formDataPutRequest(RESTAURANT_THEME.UPDATE, data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Function to fetch data from database
const getThemeSettings = (id) => {
  return getRequest(`${RESTAURANT_THEME.GET}/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Delete themesetting logo
const deleteThemeSettingLogo = (brandId) => {
  return putRequest(`${RESTAURANT_THEME.DELETE_LOGO}/${brandId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Exporting functions for other files
export const themeSettingsService = {
  getThemeSettings,
  updateThemeSettings,
  deleteThemeSettingLogo,
};
